module.exports = __webpack_public_path__ + "img/menu-hopital-shriners.37ff63c9.jpg";